export const FETCH_FILTER_BRANDS_BEGIN = 'FETCH_FILTER_BRANDS_BEGIN';
export const FETCH_FILTER_BRANDS_SUCCESS = 'FETCH_FILTER_BRANDS_SUCCESS';
export const FETCH_FILTER_BRANDS_FAILURE = 'FETCH_FILTER_BRANDS_FAILURE';
export const FETCH_COMMON_DETAILS_BEGIN = 'FETCH_COMMON_DETAILS_BEGIN';
export const FETCH_COMMON_DETAILS_SUCCESS = 'FETCH_COMMON_DETAILS_SUCCESS';
export const FETCH_COMMON_DETAILS_FAILURE = 'FETCH_COMMON_DETAILS_FAILURE';
